<template>
  <div class="assign-items">
    <div class="col-md-12 row align-items-end no-padding no-margin subheader-assign d-flex align-items-center">
      <div class="col-8 no-padding">
        {{
          $t('apps.inventory.message.assignofskus', {
            selected_count: this.input.length,
            items_count: this.items.length,
          })
        }}
      </div>
      <div class="col-4 no-padding text-right">
        <button
          v-if="!disabled"
          class="btn btn-sm"
          @click="onSelectedAll">
          {{ $t('button.selectall') }}
        </button>
      </div>
    </div>
    <div class="container-items">
      <div
        v-for="(item, index) in mapItems"
        :class="['col-md-12 row align-items-center no-margin item', { active: item.active }, { disabled: item.disabled || disabled }]"
        :key="index"
        @click="toggle(item)"
      >
        <vs-tooltip
          v-if="item.disabled && (disabledItemMessage === undefined || typeof disabledItemMessage === 'string')"
          :text="tooltipMessage"
          position="left"
          class="d-flex w-100"
        >
          <div :class="`col-${colName}`">
            {{ item.text }}
          </div>
          <div :class="`col-${colValue} text-right`">
            <i class="fas fa-check-circle"/>
            <i class="far fa-circle"/>
          </div>
        </vs-tooltip>
        <template v-else>
          <div :class="`col-${colName}`">
            {{ item.text }}
          </div>
          <div :class="`col-${colValue} text-right`">
            {{ item.textRight }}
            <i class="fas fa-check-circle"/>
            <i class="far fa-circle"/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    items: Array,
    colName: {
      type: Number,
      default: 9,
    },
    colValue: {
      type: Number,
      default: 3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledItemMessage: String | Boolean,
  },

  data () {
    return {
      input: [],
      selectedAll: false,
    }
  },

  computed: {
    mapItems () {
      return this.items.map((item) => {
        const active = this.input.some((v) => v.value === item.value)
        return { ...item, active }
      })
    },
    tooltipMessage() {
      return this.disabledItemMessage || this.$t('apps.inventory.message.thisitemcannotbeunselected')
    },
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },

  methods: {
    toggle (item) {
      if (this.disabled) {
        return
      }

      if (!item.disabled) {
        const found = this.input.some((v) => v.value === item.value)
        if (!found) {
          this.addItem(item)
        } else {
          this.removeItem(item)
        }
      }
    },
    addItem (item) {
      this.input.push(item)
    },
    removeItem ({ value }) {
      const index = this.input.findIndex((item) => item.value === value)
      this.input.splice(index, 1)
    },
    onSelectedAll () {
      const isSelectedAll = this.input.length === this.items.length
      if (isSelectedAll) {
        this.input = this.items.reduce((acc, cur) => {
          if (cur.disabled) {
            acc.push(cur)
          }
          return acc
        }, [])
      } else {
        this.input = this.items.reduce((acc, cur) => {
          if (cur.disabled || (!cur.disabled && !cur.active)) {
            acc.push(cur)
          }
          return acc
        }, [])
      }
    },
  },
}
</script>

<style scoped>
.container-items {
  max-height: 351px;
  overflow-y: auto;
}

.container-items::-webkit-scrollbar {
  width: 8px;
}

.container-items::-webkit-scrollbar-track {
  background-color: #e6e6e6;
  border-radius: 4px;
}

.container-items::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 4px;
}

.item {
  padding: 6px 0 6px 0;
}

.item.disabled {
  cursor: default;
  background: rgba(216, 226, 231, .15);
}
.item.disabled div {
  opacity: 0.6;
}
/* .item.disabled div:nth-child(1) {
  opacity: 0.6;
} */
/* .item.disabled div:nth-child(2) {
  opacity: 0.3;
} */
</style>



// WEBPACK FOOTER //
// src/components/base/BaseAssignSkus.vue